import { createContext, useContext } from 'react'

export const ModalContext = createContext()

export const ModalProvider = ModalContext.Provider
export const ModalConsumer = ModalContext.Consumer

export const useModalContext = () => useContext(ModalContext)
